import React from 'react';
import { useState } from 'react';

const ProductCard = ({
                         name,
                         price,
                         image,
                         stock,
                     }) => {
    const [imgLoaded, setImgLoaded] = useState(false);

    return (
        <div className="card h-100 border-0 shadow-sm">
            <div className="ratio ratio-1x1">
                {!imgLoaded && (
                    <div className="bg-light rounded placeholder w-100 h-100" />
                )}
                <img
                    src={image?.[0]}
                    alt={name}
                    onLoad={() => setImgLoaded(true)}
                    className={`img-fluid rounded ${!imgLoaded ? "d-none" : ""}`}
                    style={{ objectFit: "cover" }}
                />
            </div>

            <div className="card-body d-flex flex-column p-2">
                <h6 className="fw-bold mb-1 lh-sm">{name}</h6>
                <div className="text-muted small mb-1">Rs. {price}</div>

                <span
                    className={`badge align-self-start ${
                        stock > 0
                            ? "bg-success-subtle text-success"
                            : "bg-danger-subtle text-danger"
                    }`}
                >
          {stock > 0 ? "In Stock" : "Out of Stock"}
        </span>

                <button
                    className="btn btn-primary rounded-pill mt-auto w-100"
                    disabled={stock <= 0}
                    data-bs-toggle="modal"
                    data-bs-target="#extras"
                >
                    ADD
                </button>
            </div>
        </div>
    );
};
export default ProductCard;
